document.addEventListener("DOMContentLoaded", function () {
  const plusBtn = document.querySelector(".product-form__quantity .plus");
  const minBtn = document.querySelector(".product-form__quantity .min");
  const qtyInput = document.querySelector(".quantity__input");

  plusBtn.addEventListener("click", function () {
    let currentValue = parseInt(qtyInput.value);
    qtyInput.value = currentValue + 1;
  });

  minBtn.addEventListener("click", function () {
    let currentValue = parseInt(qtyInput.value);
    if (currentValue > 1) {
      qtyInput.value = currentValue - 1;
    }
  });
});
let isSyncing = false;

function syncInputsByCheckerId(checkerId, value) {
  if (isSyncing) return; // Prevent recursive loop

  isSyncing = true;
  try {
    // Find all inputs with the given checkerId
    const inputs = document.querySelectorAll(
      `[data-checker-id="${checkerId}"]`,
    );
    console.log(`Inputs found for checkerId="${checkerId}":`, inputs);

    if (inputs.length === 0) {
      console.warn(`No inputs found with data-checker-id="${checkerId}".`);
    }

    inputs.forEach((input) => {
      if (input.checked !== value) {
        input.checked = value; // Update checked state
        console.log(
          `Updated input with data-checker-id="${checkerId}" to checked=${value}`,
        );
      }
    });
  } catch (error) {
    console.error("Error in syncInputsByCheckerId:", error);
  } finally {
    isSyncing = false; // Reset the flag
  }
}

function handleCheckerIdChange(event) {
  if (!event.target || !event.target.dataset.checkerId) return;

  const checkerId = event.target.dataset.checkerId;
  const isChecked = event.target.checked;

  console.log(
    `Handling change for checkerId="${checkerId}" with checked=${isChecked}`,
  );

  // Sync all inputs with the same checkerId
  syncInputsByCheckerId(checkerId, isChecked);
}

// Attach event listeners
function initializeEventListeners() {
  const inputs = document.querySelectorAll("[data-checker-id]");
  console.log(`Initializing event listeners for inputs:`, inputs);

  inputs.forEach((input) => {
    input.addEventListener("change", handleCheckerIdChange);
  });
}

// Ensure the script initializes after DOM content is loaded
document.addEventListener("DOMContentLoaded", () => {
  initializeEventListeners();
});
document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("form-submitted")) {
    const popup = document.querySelector("#popupSubmitted");
    if (popup) {
      popup.classList.remove("hidden");
    }
  }
});
